import PrintableMonitoredBy from './PrintableMonitoredBy';

export default PrintableMonitoredBy;
